import { useTranslation } from 'react-i18next'

import { Avatar, AVATAR_HEIGHT_40 } from '../../../Avatar'
import { EntityStatus } from '../../../Entity'
import { ICON_COLOR } from '../../../Icon'
import {
  APPLICANT_STAGES,
  getIsRentalPortalApplicantIdentityMasked,
  getRentalPortalApplicantIdentityLabel,
  getRentalPortalApplicantIdentityName,
} from '../../../RentalPortalApplicant'
import Text from '../../../Text'

import * as styles from './ViewingApplicantPreviewIdentity.module.css'

import LockIcon from '../../../../icons/lock.svg'

function ViewingApplicantPreviewIdentity({ applicant, stage }) {
  const { t } = useTranslation()

  return (
    <div className={styles.ViewingApplicantPreviewIdentity}>
      <Avatar
        Icon={
          getIsRentalPortalApplicantIdentityMasked(applicant) ? LockIcon : null
        }
        color={applicant.avatar_color}
        iconProps={{ color: ICON_COLOR.SecondaryTextColor }}
        size={AVATAR_HEIGHT_40}
        text={getRentalPortalApplicantIdentityName(applicant)}
      />
      <Text className={styles.name}>
        {getRentalPortalApplicantIdentityLabel({ applicant, t })}
      </Text>
      {APPLICANT_STAGES[stage] ? (
        <EntityStatus
          className={styles.stage}
          id={stage}
          statuses={APPLICANT_STAGES}
        />
      ) : null}
    </div>
  )
}

export default ViewingApplicantPreviewIdentity
